import React from 'react'

import HowToDialog from 'components/HowToDialog'
import T from 'components/FormattedMessage'

import eventRibbonUrl from './assets/contest_tutorial_image.svg'

interface Props {
  open: boolean
  onClose?: () => void
}

const EventsIntro: React.SFC<Props> = ({ open, onClose }) => (
  <HowToDialog
    open={open}
    onClose={onClose}
    displayNew
    variant="dark"
    icon={<img alt="" src={eventRibbonUrl} />}
    headline={<T id="contests_intro_title" />}
    message={<T id="contests_intro_message" />}
    actionLabel={<T id="contests_intro_accept" />}
  />
)

export default EventsIntro
